module.exports = __webpack_public_path__ + "static/media/bonusu_rats_3_vip_min.cd69dadd.png";